import $ from 'jquery'
import select2 from 'select2'

// select2's CommonJS build exports a factory that attaches the plugin to a jQuery instance
select2(window, $)

class ChampionSelect {

  constructor(elementSelector) {
    this.selectField = $(elementSelector)
  }

  formatState(state) {
    if (!state.id || !state.element.dataset['lolId']){
      return state.text;
    }

    var $state = $(
      '<span><img src="' + state.element.dataset['image'] + '" class="champion-thumbnail" /> ' + state.text + '</span>'
    );
    return $state;
  }

  startChampionSelect() {
    this.selectField.select2({
      // theme: "foundation",
      templateResult: this.formatState,
      templateSelection: this.formatState,
      placeholder: 'Select a champion'
    })
  }

  bindSelection() {
    this.selectField.on('change', (event) => {
      var option = event.target.options[event.target.options.selectedIndex];
      var slug = option.dataset['slug'];

      if (slug) {
        window.location = '/league_of_legends/champions/' + slug;
      }
    })
  }

  start() {
    this.startChampionSelect();
    this.bindSelection()
  }
}

document.addEventListener('turbo:load', () =>
  (new ChampionSelect("#champion-select")).start()
) 
